import { LESSON_CONTENT_TYPE } from "../../utils";
import {
  ADD_ALL_COMMUNITIES,
  DELETE_ALL_COMMUNITIES,
  EDIT_ALL_COMMUNITIES,
  GET_ALL_COMMUNITIES,
  RESET_COMMUNITIES_DETAILS,
  CREATE_COURSE_SUCCESS,
  DELETE_COURSE_SUCCESS,
  GET_ALL_COURSE_LIST_SUCCESS,
  GET_COURSE_DETAILS_SUCCESS,
  GET_COURSE_LIST_SUCCESS,
  RESET_COURSE_DETAILS,
  RESET_UPDATE_COURSE_DETAILS,
  RESET_UPDATE_COMMUNITY_DETAILS,
  SET_COURSE_FOR_UPDATE,
  SET_COURSE_VALUE,
  SET_LOCAL_NEW_COURSE,
  UPDATE_COURSE_SUCCESS,
  GET_ALL_COMMUNITY_LIST_SUCCESS,
  SET_LOCAL_NEW_COMMUNITY,
  SET_COMMUNITY_VALUE,
  SET_COMMUNITY_FOR_UPDATE,
  GET_SINGLE_COMMUNITIES,
  GET_LESSON_LIST_SUCCESS,
  CREATE_LESSON_SUCCESS,
  RESET_LESSONS_DETAILS,
  DELETE_LESSON_SUCCESS,
  GET_LESSON_DETAILS_SUCCESS,
  RESET_UPDATE_LESSON_DETAILS,
  UPDATE_LESSSON_SUCCESS,
  GET_LESSON_CONTENT_SUCCESS,
  CREATE_LESSON_CONTENT_SUCCESS,
  UPDATE_LESSON_CONTENT_SUCCESS,
  DELETE_LESSON_CONTENT_SUCCESS,
  GET_SURVEYS_SUCCESS,
  CREATE_SURVEY_SUCCESS,
  UPDATE_SURVEY_SUCCESS,
  DELETE_SURVEY_SUCCESS,
  GET_SURVEY_DETAILS_SUCCESS,
  GET_SURVEY_QUESTIONS_SUCCESS,
  GET_SURVEY_QUESTIONS_DETAILS_SUCCESS,
  CREATE_SURVEY_QUESTIONS_SUCCESS,
  UPDATE_SURVEY_QUESTIONS_SUCCESS,
  DELETE_SURVEY_QUESTIONS_SUCCESS,
  CREATE_DUPLIACTE_SURVEY_SUCCESS,
  CREATE_DROPBOX_SUCCESS,
  GET_DROPBOX_LIST_SUCCESS,
  EDIT_DROPBOX_SUCCESS,
  DELETE_DROPBOX_SUCCESS,
  RESET_DROPBOX_DETAILS,
  RESET_UPDATE_SURVEY_QUESTIONS_DETAILS,
  SET_LOCAL_NEW_SURVEY,
  SET_SURVEY_VALUE,
  SET_SURVEY_FOR_UPDATE,
  GET_SURVEY_ANSWER_SUCCESS,
  SET_BULK_FILE_LIST_DROPBOX,
  DELETE_BULK_UPLOAD_FILE_DROPBOX,
  SET_BULK_UPLOAD_FILE_PROGRESS_DROPBOX,
  RESET_SURVEY_SUCCESS,
  GET_ATTENDEE_SUCCESS,
  CREATE_ATTENDEE_SUCCESS,
  CREATE_SURVEY_ANSWER_SUCCESS,
  DELETE_ATTENDEE_SUCCESS,
  DELETE_MANY_ATTENDEES_SUCCESS,
  GET_ANNOUNCEMENT_SUCCESS,
  DELETE_ANNOUNCEMENT_SUCCESS,
  UPDATE_ANNOUNCEMENT_SUCCESS,
  GET_ANNOUNCEMENT_DETAIL_SUCCESS,
  RESET_UPDATE_ANNOUNCEMENT_DETAILS,
  GET_COURSE_ATTENDEES_SUCCESS,
  READ_ANNOUNCEMENT_SUCCESS,
  SET_CURRENT_LESSON_CONTENT,
  RESET_CURRENT_LESSON_CONTENT,
  UPDATE_LESSON_CONTENT_VALUE,
  GET_LESSON_CONTENT_DETAIL_SUCCESS,
  RESET_LESSON_CONTENT_DETAIL,
  STUDENT_VIEW_CONTENT_LIST_SUCCESS,
  LESSON_CONTENT_MARK_COMPLETE_IN_COMPLETE_SUCCESS,
  GET_LESSON_PROGRESS_LIST_SUCCESS,
  RESET_LESSON_PROGRESS_LIST,
  SET_COURSE_DETAILS,
  GET_COURSE_USER_DETAIL_LIST_SUCCESS,
  RESET_COURSE_USER_DETAIL_LIST_SUCCESS,
  GET_COURSE_SYLLABUS_LIST_SUCCESS,
  GET_COURSE_SYLLABUS_LIST_FAILED,
  GET_COURSE_ATTENDEES_FAILED,
  GET_COURSE_ATTENDEES_DETAILS,
  GET_COURSE_USER_DETAIL_LIST_FAILED,
  RESET_CURRENT_COURSE_DETAILS,
  CLONE_COURSE_SUCCESS,
  ENROLL_TO_SURVEY_SUCCESS,
  EXCLUDE_FROM_SURVEY_SUCCESS,
  GET_LESSON_DETAILS_BY_COURSEID,
  UPDATE_FILE_URL,
  GET_COURSE_PROGRESS_SUCCESS,
  GET_TOTAL_USAGE_SIX_MONTHS_SUCCESS,
  GET_TERMS_COURSE_SUCCESS,
  UPDATE_LESSON_SETTING_SUCCESS,
  GET_SPECEFIC_LESSON_PROGRESS_LIST_SUCCESS,
  RESET_SPECEFIC_LESSON_PROGRESS_LIST,
  LESSON_STATUS_CHANGE,
  GET_LESSON_PROGRESS_SUCCESS,
  UPDATE_LESSON_ORDER_SUCCESS,
  GET_SINGLE_DROPBOX_LIST_SUCCESS,
  GET_SINGLE_DROPBOX_LIST_FAILED,
  RESET_LESSON_CONTENT,
  RESET_SURVEYS_DETAILS,
  RESET_LESSON_BY_COURSE,
  GET_LESSON_CONTENT_DETAIL_NEXT_PAGE_SUCCESS,
  RESET_LESSON_CONTENT_DETAIL_NEXT_PAGE,
  GET_MASTER_COURSE_LIST_SUCCESS,
  GET_MASTER_COURSE_LIST_FAILED,
  GET_LESSON_CONTENT_DETAIL_BY_LESSON_ID_SUCCESS,
  GET_LESSON_CONTENT_DETAIL_BY_LESSON_ID_FAILED,
  GET_SINGLE_COURSE_ATTENDEE,
  UPDATE_COURSE_TERMS_SUCCESS,
  GET_COURSE_BY_USER_ID_SUCCESS,
  GET_COURSE_BY_USER_ID_FAILED,
  UPDATE_LEAVRNING_CHECKLIST_SUCCESS,
  UPDATE_COURSE_EVALUATION_TERMS_SUCCESS,
  VERIFY_LEARNER_SUCCESS,
  UPDATE_LEARNING_VERIFICATION_SUCCESS,
  RESET_LEARNER_SUCCESS,
  SHOW_GRADEBOOK_FINALIZE_SUCCESS,
  SHOW_GRADEBOOK_FINALIZE_ERROR,
  GET_LEARNER_VERIFICATION_FACILITATOR_SUCCESS,
  GET_LEARNER_VERIFICATION_FACILITATOR_ERROR,
} from "../constants";
import { cloneDeep, remove, findIndex } from "lodash";

export const initialState = {
  communitiesDetails: undefined,
  currentCourse: undefined,
  currentCommunities: undefined,
  courseDetails: undefined,
  updateCourseDetails: undefined,
  updateCommunityDetails: undefined,
  courseList: [],
  communitiesList: [],
  // lessons
  lessonsDetails: undefined,
  lessonProgressDetails: undefined,
  lessonProgressDetailsSpecefic: undefined,
  updateLessonDetails: undefined,
  lessonsList: [],
  statusChanged: false,
  // lessons content
  lessonsContentDetails: undefined,
  lessonByCourse: undefined,
  //surveys
  surveyDetails: undefined,
  singleSurveyDetails: undefined,
  surveyAnswers: undefined,
  surveyAnswerDetails: undefined,
  bulkFileList: [],
  resetSurvey: false,
  masterCourse: undefined,

  //surveyQuestion
  surveyQuestionDetails: undefined,
  singleSurveyQuestionDetails: undefined,
  //Dropbox
  dropboxDetails: undefined,
  currentSurvey: undefined,
  surveyCurrentUpdate: undefined,

  //courseAttendees
  courseAttendees: undefined,
  courseAllAttendees: undefined,
  singleCourseAttendee: undefined,
  singleCourseAttendeEvalution: undefined,
  //courseAnnouncement
  courseAnnouncement: undefined,
  courseAnnouncementdetail: undefined,
  read: false,

  //course all Users
  courseUsers: undefined,

  // lesson content
  currentLessonContent: undefined,
  lessonContentNextPage: undefined,

  //  lesson content details
  lessonContentDetails: undefined,
  studentLessonContentList: [],

  //course details
  courseInfo: undefined,

  //courseUser List
  courseUserList: [],
  cousreUserLoading: false,

  // course Syllabus
  courseSyllbusList: [],

  // User Courses
  userCourseList: [],

  //cloning
  courseCloned: false,
  fileURL: null,

  // course progress
  courseProgress: undefined,
  totalUsageSixMonths: undefined,
  // course Tearms
  courseTearms: undefined,
  singleFileUpload: undefined,
  lessonContentDetailsByLessonId: undefined,

  ///learner-verification
  verificationResult: false,

  verificationlearningResult: undefined,

  gradebookNotification: undefined,
  learnerVerificationFacilitator: undefined,
};
export const CourseReducer = (state = initialState, action) => {
  //switch between action.type
  switch (action.type) {
    case GET_LESSON_CONTENT_DETAIL_BY_LESSON_ID_SUCCESS: {
      return {
        ...state,
        lessonContentDetailsByLessonId: action.payload,
      };
    }
    case GET_LESSON_CONTENT_DETAIL_BY_LESSON_ID_FAILED: {
      return {
        ...state,
        lessonContentDetailsByLessonId: undefined,
      };
    }
    case GET_COURSE_PROGRESS_SUCCESS: {
      console.log("courseProgress: ", action.payload);
      return {
        ...state,
        courseProgress: action.payload,
      };
    }
    case GET_SINGLE_DROPBOX_LIST_SUCCESS: {
      return {
        ...state,
        singleFileUpload: action.payload,
      };
    }
    case GET_SINGLE_DROPBOX_LIST_FAILED: {
      return {
        ...state,
        singleFileUpload: undefined,
      };
    }
    case GET_TERMS_COURSE_SUCCESS: {
      return {
        ...state,
        courseTearms: action.payload,
      };
    }
    case GET_TOTAL_USAGE_SIX_MONTHS_SUCCESS: {
      return {
        ...state,
        totalUsageSixMonths: action.payload,
      };
    }
    case SET_LOCAL_NEW_COMMUNITY:
      return {
        ...state,
        currentCommunities: action.payload,
      };

    case SET_LOCAL_NEW_COURSE:
      return {
        ...state,
        currentCourse: action.payload,
      };
    case SET_LOCAL_NEW_SURVEY:
      return {
        ...state,
        currentSurvey: action.payload,
      };
    case SET_COMMUNITY_VALUE: {
      const tempCurrentCommunity = cloneDeep(state.currentCommunities);
      tempCurrentCommunity[action.payload.key] = action.payload.value;
      return {
        ...state,
        currentCommunities: tempCurrentCommunity,
      };
    }
    case SET_COURSE_VALUE: {
      const tempCurrentCourse = cloneDeep(state.currentCourse);
      tempCurrentCourse[action.payload.key] = action.payload.value;
      return {
        ...state,
        currentCourse: tempCurrentCourse,
      };
    }
    case SET_SURVEY_VALUE: {
      const tempSurveyCommunity = cloneDeep(state.currentSurvey);
      tempSurveyCommunity[action.payload.key] = action.payload.value;
      return {
        ...state,
        currentSurvey: tempSurveyCommunity,
      };
    }
    case SET_COURSE_FOR_UPDATE: {
      return {
        ...state,
        currentCourse: action.payload,
      };
    }
    case SET_COMMUNITY_FOR_UPDATE: {
      return {
        ...state,
        currentCommunities: action.payload,
      };
    }
    case SET_SURVEY_FOR_UPDATE: {
      return {
        ...state,
        currentSurvey: action.payload,
      };
    }

    case GET_COURSE_LIST_SUCCESS: {
      return {
        ...state,
        courseDetails: action.payload,
      };
    }
    case CREATE_COURSE_SUCCESS: {
      const tempCourseDetails = cloneDeep(state.courseDetails);
      tempCourseDetails.data.splice(0, 0, action.payload);
      return {
        ...state,
        courseDetails: tempCourseDetails,
      };
    }
    case DELETE_COURSE_SUCCESS: {
      const tempCourseDetails = cloneDeep(state.courseDetails);
      remove(tempCourseDetails.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        courseDetails: tempCourseDetails,
      };
    }
    case GET_ALL_COURSE_LIST_SUCCESS: {
      return {
        ...state,
        courseList: action.payload,
      };
    }
    case GET_COURSE_DETAILS_SUCCESS: {
      return {
        ...state,
        updateCourseDetails: action.payload,
      };
    }
    case GET_SINGLE_COMMUNITIES: {
      return {
        ...state,
        updateCommunityDetails: action.payload,
      };
    }
    case UPDATE_COURSE_SUCCESS: {
      const tempCourseDetails = cloneDeep(state.courseDetails);
      const index = findIndex(
        tempCourseDetails.data,
        (obj) => obj._id === action.payload._id
      );

      if (index !== -1) {
        tempCourseDetails.data[index] = action.payload;
      }
      return {
        ...state,
        courseDetails: tempCourseDetails,
      };
    }

    case RESET_COURSE_DETAILS: {
      return {
        ...state,
        courseDetails: undefined,
        currentCourse: undefined,
        updateCourseDetails: undefined,
        updateLessonDetails: undefined,
        courseList: [],
      };
    }
    //Communities
    case GET_ALL_COMMUNITIES: {
      return {
        ...state,
        communitiesDetails: action.payload,
      };
    }
    case GET_ALL_COMMUNITY_LIST_SUCCESS: {
      return {
        ...state,
        communitiesList: action.payload,
      };
    }
    case DELETE_ALL_COMMUNITIES: {
      const tempDeleteComm = cloneDeep(state.communitiesDetails);
      remove(tempDeleteComm.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        communitiesDetails: tempDeleteComm,
      };
    }
    case EDIT_ALL_COMMUNITIES: {
      const tempEditComm = cloneDeep(state.communitiesDetails);

      const index = tempEditComm.data.findIndex(
        (obj) => obj._id === action.payload._id
      );
      if (index !== -1) {
        tempEditComm.data[index] = action.payload;
      }

      return {
        ...state,
        communitiesDetails: tempEditComm,
      };
    }
    case ADD_ALL_COMMUNITIES: {
      const tempAddComm = cloneDeep(state.communitiesDetails);
      tempAddComm.data.splice(0, 0, action.payload);
      return {
        ...state,
        // communitiesDetails: action.payload,
        communitiesDetails: tempAddComm,
      };
    }

    case RESET_COMMUNITIES_DETAILS: {
      return {
        ...state,
        communitiesDetails: undefined,
        updateCommunityDetails: undefined,
        communitiesList: [],
      };
    }
    case RESET_UPDATE_COURSE_DETAILS: {
      return {
        ...state,
        updateCourseDetails: undefined,
      };
    }
    case RESET_UPDATE_COMMUNITY_DETAILS: {
      return {
        ...state,
        updateCommunityDetails: undefined,
      };
    }
    case GET_LESSON_LIST_SUCCESS: {
      return {
        ...state,
        lessonsDetails: action.payload,
      };
    }
    case RESET_LESSON_CONTENT: {
      return {
        ...state,
        lessonsDetails: undefined,
      };
    }

    case GET_LESSON_PROGRESS_LIST_SUCCESS: {
      return {
        ...state,
        lessonProgressDetails: action.payload,
      };
    }
    case GET_SPECEFIC_LESSON_PROGRESS_LIST_SUCCESS: {
      return {
        ...state,
        lessonProgressDetailsSpecefic: action.payload,
      };
    }
    case RESET_LESSON_PROGRESS_LIST: {
      return {
        ...state,
        lessonProgressDetails: undefined,
      };
    }
    case RESET_SPECEFIC_LESSON_PROGRESS_LIST: {
      return {
        ...state,
        lessonProgressDetailsSpecefic: undefined,
      };
    }
    case CREATE_LESSON_SUCCESS: {
      const tempLessonDetails = cloneDeep(state.lessonsDetails);
      tempLessonDetails.data.splice(0, 0, action.payload);
      return {
        ...state,
        lessonsDetails: tempLessonDetails,
      };
    }
    case DELETE_LESSON_SUCCESS: {
      const tempLessonDetails = cloneDeep(state.lessonsDetails);
      remove(tempLessonDetails.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        lessonsDetails: tempLessonDetails,
      };
    }
    case GET_LESSON_DETAILS_BY_COURSEID: {
      return {
        ...state,
        lessonByCourse: action.payload,
      };
    }
    case GET_LESSON_DETAILS_SUCCESS: {
      return {
        ...state,
        updateLessonDetails: action.payload,
      };
    }

    case RESET_UPDATE_LESSON_DETAILS: {
      return {
        ...state,
        updateLessonDetails: undefined,
      };
    }
    case RESET_LESSONS_DETAILS: {
      return {
        ...state,
        lessonsDetails: undefined,
        lessonProgressDetails: undefined,
      };
    }

    case UPDATE_LESSSON_SUCCESS: {
      const tempLessonDetails = cloneDeep(state.lessonsDetails);
      const index = findIndex(
        tempLessonDetails.data,
        (obj) => obj._id === action.payload._id
      );
      if (index !== -1) {
        tempLessonDetails.data[index] = action.payload;
      }
      return {
        ...state,
        lessonsDetails: tempLessonDetails,
      };
    }
    case GET_LESSON_CONTENT_SUCCESS: {
      return {
        ...state,
        lessonsContentDetails: action.payload,
      };
    }
    // case UPDATE_LESSON_ORDER_SUCCESS: {
    //   const templessonsContentDetails = cloneDeep(state.lessonsContentDetails);
    //   const index = findIndex(
    //     templessonsContentDetails.data,
    //     (obj) => obj._id === action.payload._id
    //   );
    //   if (index !== -1) {
    //     templessonsContentDetails.data[index] = action.payload;
    //   }
    //   return {
    //     ...state,
    //     lessonsContentDetails: templessonsContentDetails,
    //   };
    // }
    case UPDATE_LESSON_ORDER_SUCCESS:
      // Create a deep clone to avoid mutating the state directly
      const templessonsContentDetails = cloneDeep(state.lessonsContentDetails);

      // Find the index of the item to update
      const index = findIndex(
        templessonsContentDetails.data,
        (obj) => obj._id === action.payload._id
      );

      // If the item is found, update it
      if (index !== -1) {
        templessonsContentDetails.data[index] = action.payload;
      }
      console.log(
        "templessonsContentDetails before return: ",
        templessonsContentDetails
      );

      // Return updated state without reloading the page
      return {
        ...state,
        lessonsContentDetails: templessonsContentDetails,
      };
    case CREATE_LESSON_CONTENT_SUCCESS: {
      const tempLessonContentDetails = cloneDeep(state.lessonsContentDetails);
      tempLessonContentDetails.data.splice(0, 0, action.payload);
      return {
        ...state,
        lessonsContentDetails: tempLessonContentDetails,
      };
    }
    case UPDATE_LESSON_CONTENT_SUCCESS: {
      const templessonsContentDetails = cloneDeep(state.lessonsContentDetails);
      const index = findIndex(
        templessonsContentDetails.data,
        (obj) => obj._id === action.payload._id
      );
      if (index !== -1) {
        templessonsContentDetails.data[index] = action.payload;
      }
      return {
        ...state,
        lessonsContentDetails: templessonsContentDetails,
      };
    }

    case DELETE_LESSON_CONTENT_SUCCESS: {
      const tempLessonsContentDetails = cloneDeep(state.lessonsContentDetails);
      remove(
        tempLessonsContentDetails.data,
        (obj) => obj._id === action.payload
      );
      return {
        ...state,
        lessonsContentDetails: tempLessonsContentDetails,
      };
    }

    //survey
    case GET_SURVEYS_SUCCESS:
      return {
        ...state,
        surveyDetails: action.payload,
      };
    case GET_SURVEY_DETAILS_SUCCESS:
      return {
        ...state,
        singleSurveyDetails: action.payload,
      };
    case GET_MASTER_COURSE_LIST_SUCCESS: {
      return {
        ...state,
        masterCourse: action.payload,
      };
    }
    case GET_MASTER_COURSE_LIST_FAILED: {
      return {
        ...state,
        masterCourse: undefined,
      };
    }
    case CREATE_SURVEY_SUCCESS:
      const tempSurveyAddDetails = cloneDeep(state.surveyDetails);
      tempSurveyAddDetails.data.splice(0, 0, action.payload);
      return {
        ...state,
        surveyDetails: tempSurveyAddDetails,
      };

    case CREATE_DUPLIACTE_SURVEY_SUCCESS:
      const duplicateSurveyDetails = cloneDeep(state.surveyDetails);
      duplicateSurveyDetails.data.splice(0, 0, action.payload);
      return {
        ...state,
        surveyDetails: duplicateSurveyDetails,
      };

    case UPDATE_SURVEY_SUCCESS: {
      const tempSurveyUpdateDetails = cloneDeep(state.surveyDetails);
      const index = findIndex(tempSurveyUpdateDetails.data, {
        _id: action.payload.id,
      });
      if (index !== -1) {
        const updatedObj = { ...action.payload, _id: action.payload.id };
        tempSurveyUpdateDetails.data.splice(index, 1, updatedObj);
      }
      return {
        ...state,
        surveyDetails: tempSurveyUpdateDetails,
      };
    }
    case DELETE_SURVEY_SUCCESS:
      const tempSurveyDetails = cloneDeep(state.surveyDetails);
      remove(tempSurveyDetails.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        surveyDetails: tempSurveyDetails,
      };
    //surveyQuestions
    case GET_SURVEY_QUESTIONS_SUCCESS:
      return {
        ...state,
        surveyQuestionDetails: action.payload,
      };
    case GET_SURVEY_QUESTIONS_DETAILS_SUCCESS:
      return {
        ...state,
        singleSurveyQuestionDetails: action.payload,
      };
    case RESET_UPDATE_SURVEY_QUESTIONS_DETAILS:
      return {
        ...state,
        singleSurveyQuestionDetails: undefined,
      };
    case CREATE_SURVEY_QUESTIONS_SUCCESS:
      const tempSurveyQestionAddDetails = cloneDeep(
        state.surveyQuestionDetails
      );
      tempSurveyQestionAddDetails.data.splice(0, 0, action.payload);
      return {
        ...state,
        surveyQuestionDetails: tempSurveyQestionAddDetails,
      };
    // case UPDATE_SURVEY_QUESTIONS_SUCCESS:
    //   const tempSurveyQuestionUpdateDetails = cloneDeep(
    //     state.surveyQuestionDetails
    //   );
    //   const index = findIndex(tempSurveyQuestionUpdateDetails.data, {
    //     _id: action.payload.id,
    //   });

    //   if (index !== -1) {
    //     const updatedObj = { ...action.payload, _id: action.payload.id };
    //     tempSurveyQuestionUpdateDetails.data.splice(index, 1, updatedObj);
    //   }
    //   return {
    //     ...state,
    //     surveyQuestionDetails: tempSurveyQuestionUpdateDetails,
    //   };

    case UPDATE_LESSON_SETTING_SUCCESS: {
      let tempoResDetail = cloneDeep(state.lessonsDetails);
      const index = tempoResDetail.data.findIndex(
        (obj) => obj._id === action.payload._id
      );
      if (index !== -1) {
        tempoResDetail.data[index] = action.payload;
      }
      return {
        ...state,
        lessonsDetails: tempoResDetail,
      };
    }
    case UPDATE_SURVEY_QUESTIONS_SUCCESS: {
      const tempLessonDetails = cloneDeep(state.surveyQuestionDetails);
      const index = findIndex(
        tempLessonDetails.data,
        (obj) => obj._id === action.payload._id
      );
      if (index !== -1) {
        tempLessonDetails.data[index] = action.payload;
      }
      return {
        ...state,
        surveyQuestionDetails: tempLessonDetails,
      };
    }
    case DELETE_SURVEY_QUESTIONS_SUCCESS:
      const tempSurveyQuestionDetails = cloneDeep(state.surveyQuestionDetails);
      remove(
        tempSurveyQuestionDetails.data,
        (obj) => obj._id === action.payload
      );
      return {
        ...state,
        surveyQuestionDetails: tempSurveyQuestionDetails,
      };

    case CREATE_SURVEY_ANSWER_SUCCESS:
      const tempSurveyAnswerDetails = cloneDeep(state.surveyAnswers);
      tempSurveyAnswerDetails.data.splice(0, 0, action.payload);

      return {
        ...state,
        surveyAnswers: tempSurveyAnswerDetails,
      };

    case GET_SURVEY_ANSWER_SUCCESS:
      return {
        ...state,
        surveyAnswerDetails: action.payload,
      };

    case RESET_SURVEY_SUCCESS:
      return {
        ...state,
        resetSurvey: action.payload,
      };

    case ENROLL_TO_SURVEY_SUCCESS:
      const tempSurveyDetails2 = cloneDeep(state.singleSurveyDetails);
      const users = tempSurveyDetails2.enrolledUsers;
      for (const usr of action.payload) {
        const index = users.indexOf(usr);
        if (index === -1) {
          users.push(usr);
        }
      }
      const finalSd = { ...tempSurveyDetails2, enrolledUsers: users };
      return {
        ...state,
        singleSurveyDetails: finalSd,
      };

    case EXCLUDE_FROM_SURVEY_SUCCESS:
      const tempSurveyDetails3 = cloneDeep(state.singleSurveyDetails);
      const users2 = tempSurveyDetails3.enrolledUsers;
      for (const usr of action.payload) {
        const index = users2.indexOf(usr);
        if (index !== -1) {
          users2.splice(index, 1);
        }
      }
      const finalSd2 = { ...tempSurveyDetails3, enrolledUsers: users2 };
      return {
        ...state,
        singleSurveyDetails: finalSd2,
      };

    //Dropbox
    case GET_DROPBOX_LIST_SUCCESS: {
      return {
        ...state,
        dropboxDetails: action.payload,
      };
    }
    case CREATE_DROPBOX_SUCCESS: {
      const tempDropBoxDetails = cloneDeep(state.dropboxDetails);
      tempDropBoxDetails.data.splice(0, 0, action.payload);
      return {
        ...state,
        dropboxDetails: tempDropBoxDetails,
      };
    }
    case EDIT_DROPBOX_SUCCESS: {
      const tempDropBoxDetails = cloneDeep(state.dropboxDetails);
      const index = findIndex(tempDropBoxDetails.data, {
        _id: action.payload.id,
      });
      if (index !== -1) {
        const updatedObj = { ...action.payload, _id: action.payload.id };
        tempDropBoxDetails.data.splice(index, 1, updatedObj);
      }
      return {
        ...state,
        dropboxDetails: tempDropBoxDetails,
      };
    }
    case DELETE_DROPBOX_SUCCESS: {
      const tempDropBoxDetails = cloneDeep(state.dropboxDetails);
      remove(tempDropBoxDetails.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        dropboxDetails: tempDropBoxDetails,
      };
    }
    case RESET_DROPBOX_DETAILS: {
      return {
        ...state,
        dropboxDetails: undefined,
      };
    }
    case SET_BULK_FILE_LIST_DROPBOX: {
      // let tempBulkFileListDetails = cloneDeep(state.bulkFileList);
      // let newFiles = cloneDeep(action.payload);
      // const ftempBulkFileListDetails = tempBulkFileListDetails.concat(newFiles);
      return {
        ...state,
        bulkFileList: action.payload,
      };
    }
    case DELETE_BULK_UPLOAD_FILE_DROPBOX: {
      let tempBulkFileListDetails = cloneDeep(state.bulkFileList);
      remove(tempBulkFileListDetails, (obj) => obj.id === action.payload);
      return {
        ...state,
        bulkFileList: tempBulkFileListDetails,
      };
    }
    case SET_BULK_UPLOAD_FILE_PROGRESS_DROPBOX: {
      let tempBulkFileListDetails = cloneDeep(state.bulkFileList);
      tempBulkFileListDetails[action.payload.index].progress =
        action.payload.progress;
      tempBulkFileListDetails[action.payload.index].uploading = true;
      return {
        ...state,
        bulkFileList: tempBulkFileListDetails,
      };
    }

    case GET_SINGLE_COURSE_ATTENDEE:
      return {
        ...state,
        singleCourseAttendee: action.payload,
      };

    case UPDATE_LEAVRNING_CHECKLIST_SUCCESS: {
      return {
        ...state,
        singleCourseAttendee: action.payload,
      };
    }

    case UPDATE_COURSE_TERMS_SUCCESS:
      return {
        ...state,
        singleCourseAttendee: action.payload,
      };

    case UPDATE_COURSE_EVALUATION_TERMS_SUCCESS:
      return {
        ...state,
        singleCourseAttendeEvalution: action.payload,
      };

    case GET_ATTENDEE_SUCCESS:
      return {
        ...state,
        courseAttendees: action.payload,
      };

    case GET_COURSE_ATTENDEES_SUCCESS:
      return {
        ...state,
        courseAllAttendees: action.payload,
      };
    case GET_COURSE_ATTENDEES_FAILED:
      return {
        ...state,
        courseAllAttendees: action.payload,
      };

    case CREATE_ATTENDEE_SUCCESS:
      // const tempAttendeeAddDetails = cloneDeep(state.courseAttendees);
      // tempAttendeeAddDetails.data.splice(0, 0, action.payload);
      return {
        ...state,
        courseAttendees: action.payload,
      };

    case DELETE_ATTENDEE_SUCCESS: {
      const tempAttendeeDetails = cloneDeep(state.courseAttendees);
      remove(tempAttendeeDetails.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        courseAttendees: tempAttendeeDetails,
      };
    }

    case DELETE_MANY_ATTENDEES_SUCCESS:
      return {
        ...state,
        courseAttendees: action.payload,
      };

    //announcement
    case GET_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        courseAnnouncement: action.payload,
      };
    // case CREATE_ANNOUNCEMENT_SUCCESS:
    //   return {
    //     ...state,
    //     courseAnnouncement: action.payload,
    //   };

    case UPDATE_ANNOUNCEMENT_SUCCESS:
      // const tempAttendeeAddDetails = cloneDeep(state.courseAttendees);
      // tempAttendeeAddDetails.data.splice(0, 0, action.payload);
      return {
        ...state,
        courseAnnouncement: action.payload,
      };

    case READ_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        courseAnnouncement: action.payload,
        read: true,
      };

    case DELETE_ANNOUNCEMENT_SUCCESS: {
      const tempAnnouncement = cloneDeep(state.courseAnnouncement);
      remove(tempAnnouncement, (obj) => obj._id === action.payload);
      return {
        ...state,
        courseAnnouncement: tempAnnouncement,
      };
    }

    case GET_ANNOUNCEMENT_DETAIL_SUCCESS: {
      return {
        ...state,
        courseAnnouncementdetail: action.payload,
      };
    }

    case RESET_UPDATE_ANNOUNCEMENT_DETAILS:
      return {
        ...state,
        courseAnnouncementdetail: undefined,
      };

    case SET_CURRENT_LESSON_CONTENT:
      return {
        ...state,
        currentLessonContent: action.payload,
      };
    case GET_LESSON_CONTENT_DETAIL_NEXT_PAGE_SUCCESS: {
      return {
        ...state,
        lessonContentNextPage: action.payload,
      };
    }
    case RESET_LESSON_CONTENT_DETAIL_NEXT_PAGE: {
      return {
        ...state,
        lessonContentNextPage: undefined,
      };
    }

    case RESET_CURRENT_LESSON_CONTENT:
      return {
        ...state,
        currentLessonContent: undefined,
      };
    case UPDATE_LESSON_CONTENT_VALUE:
      const tempCurrentLessonContent = cloneDeep(state.currentLessonContent);

      if (action.payload.key) {
        tempCurrentLessonContent[action.payload.key] = action.payload.value;
      }

      // Check if contentType is an array and contains specific types
      if (
        (action.payload.key === "contentType" &&
          action.payload.value === LESSON_CONTENT_TYPE.FILE_FROM_COURSE_RES) ||
        action.payload.value === LESSON_CONTENT_TYPE.FILE_FROM_GLOBAL_REPO ||
        action.payload.value === LESSON_CONTENT_TYPE.FILE_FROM_MY_REPO ||
        action.payload.value === LESSON_CONTENT_TYPE.FOLDER_FROM_COURSE_REPO
      ) {
        tempCurrentLessonContent["resource_owner"] = "";
        tempCurrentLessonContent["resource_folder"] = "";
        tempCurrentLessonContent["resource_file"] = "";
      }

      return {
        ...state,
        currentLessonContent: tempCurrentLessonContent,
      };

    case GET_LESSON_CONTENT_DETAIL_SUCCESS:
      return {
        ...state,
        lessonContentDetails: action.payload,
      };
    case STUDENT_VIEW_CONTENT_LIST_SUCCESS:
      return {
        ...state,
        studentLessonContentList: action.payload,
      };

    case LESSON_CONTENT_MARK_COMPLETE_IN_COMPLETE_SUCCESS:
      const tempContent = cloneDeep(state.lessonContentDetails);
      const tempLessonContentList = cloneDeep(state.studentLessonContentList);
      tempContent["status"] = action.payload;
      const index_1 = tempLessonContentList.findIndex(
        (obj) => obj._id === action.payload.lessonContentId
      );
      if (index_1 !== -1) {
        tempLessonContentList[index_1]["lesson_status"] = [
          { status: action.payload.status },
        ];
      }
      return {
        ...state,
        lessonContentDetails: tempContent,
        studentLessonContentList: tempLessonContentList,
      };

    case LESSON_STATUS_CHANGE:
      return {
        ...state,
        statusChanged: true,
      };
    case GET_LESSON_PROGRESS_SUCCESS:
      return {
        ...state,
        statusChanged: false,
      };
    case RESET_LESSON_CONTENT_DETAIL:
      return {
        ...state,
        lessonContentDetails: undefined,
        studentLessonContentList: [],
      };
    case SET_COURSE_DETAILS:
      return {
        ...state,
        courseInfo: action.payload,
      };

    case GET_COURSE_ATTENDEES_DETAILS:
      return {
        ...state,
        cousreUserLoading: true,
      };

    case GET_COURSE_USER_DETAIL_LIST_SUCCESS:
      return {
        ...state,
        courseUserList: action.payload,
        cousreUserLoading: false,
      };
    case GET_COURSE_USER_DETAIL_LIST_FAILED:
      return {
        ...state,
        courseUserList: [],
        cousreUserLoading: false,
      };
    case RESET_COURSE_USER_DETAIL_LIST_SUCCESS:
      return {
        ...state,
        courseUserList: [],
      };

    case GET_COURSE_BY_USER_ID_SUCCESS:
      return {
        ...state,
        userCourseList: action.payload,
      };
    case GET_COURSE_BY_USER_ID_FAILED:
      return {
        ...state,
        userCourseList: [],
      };

    case GET_COURSE_SYLLABUS_LIST_SUCCESS:
      return {
        ...state,
        courseSyllbusList: action.payload,
      };
    case GET_COURSE_SYLLABUS_LIST_FAILED:
      return {
        ...state,
        courseSyllbusList: [],
      };

    case CLONE_COURSE_SUCCESS:
      return {
        ...state,
        courseCloned: true,
      };

    case RESET_CURRENT_COURSE_DETAILS:
      return {
        ...state,
        courseAttendees: undefined,
        courseAllAttendees: undefined,
        courseUserList: [],
        courseAnnouncement: [],
        courseSyllbusList: [],
        updateCourseDetails: undefined,
      };

    case UPDATE_FILE_URL:
      return {
        ...state,
        fileURL: action.payload,
      };
    case RESET_LESSON_BY_COURSE:
      return {
        ...state,
        lessonByCourse: undefined,
      };
    case RESET_SURVEYS_DETAILS:
      return {
        ...state,
        surveyDetails: undefined,
      };
    // verfify reducer
    case VERIFY_LEARNER_SUCCESS: {
      return {
        ...state,
        verificationResult: action.payload,
      };
    }

    case UPDATE_LEARNING_VERIFICATION_SUCCESS: {
      return {
        ...state,
        verificationlearningResult: action.payload,
      };
    }

    case SHOW_GRADEBOOK_FINALIZE_SUCCESS: {
      return {
        ...state,
        gradebookNotification: action.payload,
      };
    }
    case GET_LEARNER_VERIFICATION_FACILITATOR_SUCCESS: {
      return {
        ...state,
        learnerVerificationFacilitator: action.payload,
      };
    }
    case GET_LEARNER_VERIFICATION_FACILITATOR_ERROR: {
      return {
        ...state,
        learnerVerificationFacilitator: undefined,
      };
    }
    case SHOW_GRADEBOOK_FINALIZE_ERROR: {
      return {
        ...state,
        gradebookNotification: action.payload,
      };
    }
    case RESET_LEARNER_SUCCESS: {
      return {
        ...state,
        verificationResult: false,
      };
    }

    default:
      return state;
  }
};
